module.exports = __webpack_public_path__ + "static/media/goblin_brute_head.e043ae2d.png";